export default __webpack_public_path__ + "static/media/subj-completed-logo.9c2f5c48.svg";